import * as questionsApi from "api/questions.js";
import { questionPath } from "utils/questionnaire";
import { parentTopic, subTopic } from "utils/metadata";

export async function questionPropsFromParams(params) {
  const response = await questionsApi.get(params);
  const { question, index, totalCount } = response.body.data;

  return {
    question,
    links: response.body.links,
    totalCount,
    index
  };
}

export function pageTitle(question) {
  let institution = `da ${question.institution}`;
  if (question.institution == "ENEM") institution = "do ENEM";
  // TODO: Add "Prova azul, or Prova V"
  const enemDay =
    (question.institution == "ENEM" && ` dia ${question.testDay}`) || "";
  return `Resolução ${institution} ${question.year}${enemDay} - Questão ${question.examNumber}`;
}

export function metaDescription(question) {
  const subjectText = `${parentTopic(question.topics)?.name}${
    subTopic(question.topics) ? ` - ${subTopic(question.topics)?.name}` : ""
  }`;
  return `Aprenda a resolver gratuitamente a questão ${question.examNumber} ${
    question.institution === "ENEM" ? "do ENEM" : `da ${question.institution}`
  } de ${
    question.year
  } com a explicação detalhada de ${subjectText} e faça um simulado com questões parecidas.`;
}

export function canonicalUrl(question) {
  return questionPath(question);
}
